import create_org_1 from 'assets/images/guides/create-org/create-org-1.png';
import create_org_2 from 'assets/images/guides/create-org/create-org-2.png';
import create_org_3 from 'assets/images/guides/create-org/create-org-3.png';

export const create_org = [
  {
    caption: 'Open `Organisations` from the menu on the left of your screen.',
    image: create_org_1
  },
  {
    caption: 'Click the `Create organisation` button at the top-right of the table.',
    image: create_org_2
  },
  {
    caption: 'Fill in the organisation’s details, then click `Create organisation`.',
    image: create_org_3
  }
];
